/* eslint-disable react/jsx-no-target-blank */

import { FC } from 'react';
import { Typography } from '@mui/material';
import { Trans } from 'react-i18next';
import { useAppSelector } from '../../store';
import { useAppTranslation } from '../../i18n';

export const TermsFooter: FC = () => {
  const { t, i18n } = useAppTranslation();
  const panelInfo = useAppSelector((s) => s.panelInfo);
  const termsLinks = panelInfo?.app_settings?.links.filter((l) => l.type === 'terms');
  const termsLink = termsLinks.find((l) => l.language_code === i18n.language) ?? termsLinks[0];
  if (!termsLink) {
    return null;
  }
  return (
    <footer style={styles.footer}>
      <Typography sx={styles.footerText}>
        <Trans t={t} key="pleaseSeeOurTermsOfServices">
          Please see our
          <a href={termsLink.url} target="_blank" style={{ marginLeft: '0.3em', textDecoration: 'underline' }}>
            terms of services
          </a>
        </Trans>
      </Typography>
    </footer>
  );
};

const styles = {
  footer: {
    width: '100%',
    background: '#EBEBEC',
    position: 'fixed',
    bottom: 0,
  },
  footerText: {
    lineHeight: '40px',
    fontFamily: '"Open Sans", sans-serif',
    fontSize: '12px',
  },
} as const;
